<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>好评奖励配置</span>
        </div>
        <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
          <Reward :value="formData" :drawer="false"></Reward>
          <el-button type="primary" @click="handleSaveConfig()">保存</el-button>
        </el-form>

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>


import Reward from "@/components/Reward";
import {getCommonCfg, updateCommonCfg} from "@/api/config/common-cfg";
export default {
  name: 'Comment',
  components: {Reward},
  data() {
    return {
      formData: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      getCommonCfg({ name: 'CommentReward' }).then(res => {
        console.log(res)
        this.formData = res.data
      })
    },
    handleClose(d) {
      this.drawer = false
    },
    handleSaveConfig(){
      updateCommonCfg({ name: 'CommentReward', data: JSON.stringify(this.formData) }).then(res => {
        this.msgSuccess(res.msg)
      })
    },
  }
}
</script>

<style scoped>
</style>
